import React from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { companyInfo } from '../../data/mockData';
import { SocialIcons } from '../SocialIcons';

export const HeaderActions = ({ isMenuOpen, onToggleMenu }) => (
  <div className="header-actions" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
    <div className="header-social">
      <SocialIcons variant="light" size={15} />
    </div>

    <a
      href={`tel:${companyInfo.phone}`}
      className="header-phone"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.4rem',
        fontSize: '0.85rem',
        color: 'var(--text-secondary)',
        textDecoration: 'none',
        fontWeight: 500
      }}
      data-testid="header-phone"
    >
      <Phone size={15} /> {companyInfo.phone}
    </a>

    <button
      onClick={() => window.open(companyInfo.googleCalendarLink, '_blank')}
      className="btn-primary"
      style={{ padding: '0.55rem 1.1rem', fontSize: '0.85rem', minHeight: '2.5rem' }}
      data-testid="header-schedule-cta"
    >
      Schedule a Consultation
    </button>

    <button
      onClick={onToggleMenu}
      className="mobile-menu-toggle"
      style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0.4rem' }}
      aria-label="Toggle menu"
      data-testid="mobile-menu-toggle"
    >
      {isMenuOpen ? <X size={22} /> : <Menu size={22} />}
    </button>
  </div>
);
